exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Infobox{margin:160px 0 0;padding:100px 50px;width:380px;height:600px;background-color:#f8e71c;border-radius:0 20px 20px 0;position:relative}.Infobox .shadow{position:absolute;border-radius:0 20px 0 0;top:0;left:0;width:100%;height:380px;background-color:rgba(0,0,0,.1)}.Infobox .icon{height:200px;margin-bottom:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Infobox/Infobox.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/Infobox/Infobox.scss
// module chunks = 0